module.exports = __webpack_public_path__ + "static/media/image-8.4b1a6da8.jpg";